import axios from 'axios';

class RegistrationCounter {
  constructor(element) {
    this.blockElement = element;
    this.apiUrl = this.blockElement.dataset.api || null;
    this.currentRegister = this.blockElement.querySelector(
      '.registration-count-block__currentRegistration'
    );
    this.maxRegister = this.blockElement.querySelector(
      '.registration-count-block__maxRegistration'
    );
    this.htmlElement = document.documentElement;
    this.langAttribute = this.htmlElement.lang;
    this.languageCode = this.langAttribute
      ? this.langAttribute.substring(0, 2)
      : 'pl';
  }

  init() {
    if (!this.apiUrl || !this.currentRegister || !this.maxRegister) {
      console.error(
        'Brak atrybutu data-api lub elementu <span> w bloku.',
        this.blockElement
      );
      return;
    }

    this.fetchData();
  }

  async fetchData() {
    const fullApiUrl = `${this.apiUrl}${this.languageCode}`;

    try {
      const response = await axios.get(fullApiUrl);

      if (
        response.data &&
        response.data.completedRegistrationsCount !== undefined
      ) {
        const count = response.data.completedRegistrationsCount;

        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);

        this.currentRegister.textContent = formattedCount;
      } else {
        console.warn(
          `Nie znaleziono "completedRegistrationsCount" w odpowiedzi z API: ${fullApiUrl}`
        );
      }

      if (response.data && response.data.registrationLimit !== undefined) {
        const count = response.data.registrationLimit;

        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);

        this.maxRegister.textContent = formattedCount;
      } else {
        console.warn(
          `Nie znaleziono "registrationLimit" w odpowiedzi z API: ${fullApiUrl}`
        );
      }
    } catch (error) {
      console.error(
        `Błąd podczas pobierania danych z ${fullApiUrl}:`,
        error.message
      );
      this.currentRegister.textContent = '0';
      this.maxRegister.textContent = '0';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.registration-count-block')
    .forEach((blockElement) => {
      const instance = new RegistrationCounter(blockElement);

      instance.init();
    });
});
